import { throwError as observableThrowError, Observable } from 'rxjs';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FiBackendCacheService } from './fi-backend-cache.service';
import { catchError, tap } from 'rxjs/operators';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';

@Injectable()
export class FiHttpInterceptorCache implements HttpInterceptor {
    constructor(
        private backendCacheService: FiBackendCacheService,
        private fiBackend: FiBackendService,
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const cacheItem = this.backendCacheService.getCacheItem(req.url);
        if (cacheItem)
            req = req.clone({
                setHeaders: {
                    'If-None-Match': cacheItem.etag,
                },
            });

        return next.handle(req).pipe(
            tap((response) => this._do(response)),
            catchError((error: HttpErrorResponse) => this._catch(error)),
        );
    }

    private _catch(error: HttpErrorResponse) {
        if (error.status === 304) {
            const cacheItem = this.backendCacheService.getCacheItem(error.url);
            if (cacheItem)
                return Promise.resolve(
                    new HttpResponse({
                        body: cacheItem.body,
                        headers: error.headers,
                        status: error.status,
                        statusText: error.statusText,
                        url: error.url,
                    }),
                );

            return observableThrowError(error);
        } else {
            return observableThrowError(error);
        }
    }

    private _do(response) {
        if (response instanceof HttpResponse && !this.fiBackend.isExternalApiUrl(response.url)) {
            const etag: string = response.headers.get('etag');
            if (etag) {
                this.backendCacheService.setCacheItem(response.url, {
                    etag: etag,
                    body: response.body,
                });
            }
        }
    }
}
